import { DocumentConsent } from '@components/document-consent/document-consent';
import { type ApproveCreateShareSavingsAccountForChildProcessPayload, SparingApplication } from '@generated-types';
import { useAccountApproval, useAccountApprovalActions } from '@hooks/context/use-account-approval-context';
import { useLinks } from '@hooks/use-links';
import { useApproveProcess } from '@react-query/hooks/mutation/use-approve-process';
import { useTranslation } from '@translations';
import { isValidAccountApproval } from '@utils/process-form-utils';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const ApproverDocumentConsent = () => {
    const { processId } = useParams();
    const { accept, processSummary, approverParentConsent } = useTranslation();
    const navigate = useNavigate();
    const { approverParentSuccess } = useLinks();

    const accountApproval = useAccountApproval();
    const { setApproverParentHasGivenConsent } = useAccountApprovalActions();
    const { mutate: approveProcess, isPending, isSuccess } = useApproveProcess();

    const [formError, setFormError] = useState<string | undefined>(undefined);

    const onSubmit = () => {
        if (!isValidAccountApproval(accountApproval) || !processId) {
            if (!accountApproval.approverParentEmail) {
                setFormError(processSummary.email.emptyEmailError);
            } else {
                setFormError(processSummary.invalidProcessSubmitted);
            }
            return;
        }

        setFormError(undefined);

        const payload: ApproveCreateShareSavingsAccountForChildProcessPayload = {
            approverParentEmail: accountApproval.approverParentEmail,
            id: processId,
            sparingApplication: SparingApplication.MSS,
        };

        approveProcess(payload, {
            onSuccess: (response) => {
                navigate(`${approverParentSuccess.url}/${response.id}`);
            },
            onError: (_error) => {
                setFormError(approverParentConsent.approveProcessError);
            },
        });
    };

    return (
        <DocumentConsent>
            <DocumentConsent.Documents />
            <DocumentConsent.ConfirmCheckBox onValueChange={setApproverParentHasGivenConsent} />
            <DocumentConsent.FormError formError={formError} />
            <DocumentConsent.SubmitButton
                onSubmit={onSubmit}
                showSpinner={isPending}
                showSuccess={isSuccess}
                buttonText={accept}
            />
        </DocumentConsent>
    );
};
